
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/snapgene-viewer",
      function () {
        return require("private-next-pages/snapgene-viewer/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/snapgene-viewer"])
      });
    }
  